<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="省份"
                        prop="provinceid">
            <el-select v-model="search.provinceid"
                       class="width-max"
                       multiple
                       filterable
                       clearable
                       remote
                       reserve-keyword
                       placeholder="请输入省份"
                       :remote-method="getProvince">
              <el-option v-for="item in province"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       native-type="submit">搜索
            </el-button>
            <el-button icon="sj-icon-export"
                       @click="resetSearch()">重置
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <!--<el-button type="primary"-->
                   <!--size="small"-->
                   <!--icon="sj-icon-export"-->
                   <!--@click="onExportPage()"></el-button>-->
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="provincename"
                         label="省份"
                         min-width="90"></el-table-column>
        <el-table-column prop="task_count"
                         label="任务数"
                         min-width="90"></el-table-column>
        <el-table-column prop="assigned_budget"
                         label="已分配">
        </el-table-column>
        <el-table-column prop="cost"
                         label="已使用">

        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
                <el-button size="mini"
                           type="primary"
                          @click="openExecutiveDialog(scope.row)">分配
                </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <executive-budget-dialog :visible="dialogVisible" :province="projectInfo" :remainBudgetNum="remainBudget"
                             @closeDialog="dialogVisible=false"
                             @closeDialogRefresh="closeDialogRefresh"></executive-budget-dialog>
  </div>
</template>

<script>
import { searchRules } from '../executive-budget.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import ExecutiveBudgetDialog from '@/views/executive-budget/pages/ExecutiveBudgetDialog'

export default {
  components: {ExecutiveBudgetDialog},
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
      components: {
        ExecutiveBudgetDialog
      },
      exportHeader: [
        {
          key: 'id',
          text: '执行预算分配ID',
        },
        {
          key: 'name',
          text: '执行预算分配名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
      dialogVisible: false,
      projectInfo: {
        provinceid: null,
        provincename: '',
      },
      province: [],
      remainBudget: 0
    }
  },
  computed: Vuex.mapState({
    ...Vuex.mapState({
      statusMap: state => state.executiveBudget.options.status,
    }),
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params.projectid = this.$route.params.id
      let data = request.page('getExecutiveBudgetDetail', params)
      data.then((data) => {
        this.remainBudget = data.data.remain_budget
      })
      return data
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    dateFormat (row, column, cellValue, index) {
      return filter.formatDate(cellValue * 1000)
    },
    statusFormat (row, column, cellValue, index) {
      const statusMap = this.statusMap
      for (let i in statusMap) {
        if (statusMap.hasOwnProperty(i) && statusMap[i].value === cellValue * 1) {
          return statusMap[i].label
        }
      }
    },
    getProvince (query) {
      request.page('queryCitymap', {keyword: query, type: 0}).then(({data}) => {
        this.province = data
      })
    },
    openExecutiveDialog (row) {
      this.projectInfo = row
      this.dialogVisible = true
    },
    closeDialogRefresh () {
      this.dialogVisible = false
      this.$router.go(0)
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/executive-budget/pages/ExecutiveBudgetDetail.vue